import { createApp, nextTick } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import useProfileStore from "./stores/profile-store";
import request from "./utils/request";
import { clearUserData, setUserData } from "./utils/auth";

import "element-plus/theme-chalk/index.css";
import "@/styles/css-vars.css";
import "@/styles/base.css";
import "@/styles/element.css";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

(async function () {
  try {
    // 请求 aigc 用户信息，能请求成功则判断当前 cookie 有效
    const res = await request.get("/api/v1/user/info");
    if (res.code === 200) {
      setUserData(res.data);
      const profileStore = useProfileStore();
      await profileStore.initProfile();
      // console.log("init profile", profileStore.profile);
    } else {
      clearUserData();
    }
  } catch (err) {
    console.error("[app init error]:", err);
    clearUserData();
  } finally {
    nextTick(() => {
      // console.log("mount app");
      app.use(router);
      app.mount("#app");
    });
  }
})();
